import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL } from "../seoConfig";

// Componente para JSON-LD de negócio local / serviço profissional
// Ajuste address e telephone conforme necessidade.
const LocalBusinessSchema = () => {
  const data = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": `${SITE_URL}#localbusiness`,
    name: SITE_NAME,
    url: SITE_URL,
    image: [
      `${SITE_URL}banner.jpg`,
      `${SITE_URL}banner.webp`,
      `${SITE_URL}logo_icon.png`,
      `${SITE_URL}logo.png`
    ],
    // Logo principal em proporção 1:1 para Knowledge Panel / rich results
    logo: `${SITE_URL}logo_icon.png`,
    telephone: "+55 18 99799-8501",
    priceRange: "R$ R$ R$",
    parentOrganization: {
      "@type": "Organization",
      "@id": `${SITE_URL}#organization`,
      name: SITE_NAME,
      url: SITE_URL,
      logo: `${SITE_URL}logo_icon.png`
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "Rua Cristiano Olsen, 2374 - Higienópolis",
      addressLocality: "Araçatuba",
      addressRegion: "SP",
      postalCode: "16010-720",
      addressCountry: "BR"
    },
    areaServed: [
      "Araçatuba",
      "Birigui",
      "Lins",
      "Penápolis",
      "Interior de São Paulo"
    ],
    geo: {
      "@type": "GeoCoordinates",
      latitude: -21.209,
      longitude: -50.432
    },
    sameAs: [
      "https://www.instagram.com/solarsystembrasil/"
    ],
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "customer service",
        telephone: "+55 18 99799-8501",
        areaServed: ["Araçatuba", "Birigui", "Lins", "Penápolis", "Interior de São Paulo"],
        availableLanguage: ["pt-BR"]
      }
    ],
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Monday", opens: "08:00", closes: "12:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Monday", opens: "13:30", closes: "18:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Tuesday", opens: "08:00", closes: "12:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Tuesday", opens: "13:30", closes: "18:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Wednesday", opens: "08:00", closes: "12:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Wednesday", opens: "13:30", closes: "18:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Thursday", opens: "08:00", closes: "12:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Thursday", opens: "13:30", closes: "18:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "08:00", closes: "12:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Friday", opens: "13:30", closes: "18:00" }
    ],
    hasMap: "https://www.google.com/maps/place/R.+Cristiano+Olsen,+2374+-+Higien%C3%B3polis,+Ara%C3%A7atuba+-+SP,+16010-720",
    makesOffer: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Instalação de energia solar fotovoltaica",
          description: "Instalação completa de sistemas fotovoltaicos residenciais e comerciais, incluindo projeto, homologação e documentação.",
          serviceType: "Instalação de energia solar fotovoltaica",
          areaServed: ["Araçatuba", "Birigui", "Lins", "Penápolis", "Interior de São Paulo"],
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Homologação e Documentação",
          description: "Gestão de processos junto à concessionária: documentação, homologação e liberação do sistema de energia solar.",
          serviceType: "Homologação e Documentação de sistemas solares",
          areaServed: ["Araçatuba", "Birigui", "Lins", "Penápolis", "Interior de São Paulo"],
        }
      }
    ],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Serviços de Energia Solar",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: {"@type": "Service", name: "Projeto e Dimensionamento", description: "Análise de consumo e elaboração de projeto técnico otimizado para máxima geração."}
        },
        {
          "@type": "Offer",
          itemOffered: {"@type": "Service", name: "Instalação de Painéis Fotovoltaicos", description: "Instalação profissional de módulos, inversores e estrutura, seguindo normas técnicas."}
        },
        {
          "@type": "Offer",
          itemOffered: {"@type": "Service", name: "Monitoramento e Suporte", description: "Acompanhamento de performance, suporte preventivo e corretivo pós-instalação."}
        },
        {
          "@type": "Offer",
          itemOffered: {"@type": "Service", name: "Homologação e Documentação", description: "Tratativa completa com a concessionária para liberar seu sistema."}
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};

export default LocalBusinessSchema;
